import { graphql } from "react-relay";

export const saveUserSurveyResponseWrapperMutation = graphql`
  mutation SaveUserSurveyResponseWrapperMutation(
    $input: SaveUserSurveyResponseWrapperMutationInput!
  ) {
    userSurveyResponseWrapperMutations(input: $input) {
      userSurveyResponseWrapper {
        id
        userSurveyResponses {
          questionType
          responseType
          questionText
          responseText
          freeformResponse
        }
      }
    }
  }
`;
